/**
 * Servicio para manejar operaciones CRUD de exámenes.
 */
import { apiClient } from "./authService";

export const examenService = {
  /**
   * Obtiene todos los exámenes.
   */
  async obtenerTodos() {
    try {
      const response = await apiClient.get("/examenes/");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Obtiene un examen por su ID.
   */
  async obtenerPorId(examenId) {
    try {
      const response = await apiClient.get(`/examenes/${examenId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Crea un nuevo examen.
   */
  async crear(examenData) {
    try {
      const response = await apiClient.post("/examenes/", examenData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Actualiza un examen existente.
   */
  async actualizar(examenId, examenData) {
    try {
      const response = await apiClient.put(`/examenes/${examenId}`, examenData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Elimina un examen.
   */
  async eliminar(examenId) {
    try {
      const response = await apiClient.delete(`/examenes/${examenId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};






